import React from 'react';
import { enableMapSet } from 'immer';
import ReactDOM from 'react-dom/client';
import '@sites/i18n';
import App from './App';

enableMapSet();

const rootElement = document.getElementById('app');
if (!rootElement) throw new Error('Root element #app not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
